import React from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router';
import './App.scss';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import WebViews from 'components/App/WebViews/WebViews';

const theme = createMuiTheme({
  typography: {
    fontFamily: "'Roboto', sans-serif",
  },
  palette: {
    primary: {
      light: '#FFFFFF',
      main: '#FFFFFF',
      dark: '#B2B2B2',
      contrastText: '#000000',
    },
    secondary: {
      light: '#33a9f7',
      main: '#0094f6',
      dark: '#0067ac',
      contrastText: '#FFFFFF',
    },
  },
});

const App = () => {
  let routes = (
    <Switch>
      <Redirect exact from="/" to="/web" />
      <Route path="/web" component={WebViews} />
    </Switch>
  );

  return (
    <ThemeProvider theme={theme}>
      <div className="App">{routes}</div>
    </ThemeProvider>
  );
};

export default withRouter(App);
